<template>
  <div>
    <b-container fluid>
      <h1>Manage User Roles</h1>

      <b-row>
        <b-col cols="6" v-if="request != null">
            <BaseTextOutput :value="request.requestedUser.name"
                            label="Requested User"/>
        </b-col>
        <b-col cols="6" v-if="request != null">
            <BaseTextOutput :value="request.submitter.name"
                            label="Submitter"/>
        </b-col>
        <b-col cols="12" lg="4"  v-if="user != null">
            <BaseTextOutput :value="user.name"
                            label="Name"/>
        </b-col>
        <b-col cols="12" lg="4" v-if="grantedRoles != null">
            <BaseMultiCheckboxInput
                    v-model="grantedRoles"
                    label="Roles"
                    :v="$v.grantedRoles"
                    slug="grantedRoles"
                    :options="roles"
            />
        </b-col>
      </b-row>
      <b-row>
          <b-col cols="6" v-if="grantedRoles != null">
              <b-button type="button" variant="primary" @click="submit">
                  <b-spinner small v-show="loading" class="mr-2"></b-spinner>
                  Submit
              </b-button>
          </b-col>
          <b-col cols="6" v-if="request != null">
              <b-button type="button" variant="success" @click="sendApprovalEmail">
                  Send Access Granted Email
              </b-button>
              <b-button type="button" variant="danger" @click="sendDenialEmail" class="ml-2">
                  Send Access Denied Email
              </b-button>
          </b-col>
      </b-row>
      <div v-if="request === null && user == null">
          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
          <strong>Loading, Please Wait...</strong>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import axiosRetry from 'axios-retry';
import pageTitle from '@/mixins/pageTitle'
import {commonOptions} from "@/mixins/commonOptions";
import BaseMultiCheckboxInput from "../../components/BaseMultiCheckboxInput";

  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

  export default {
      components: {BaseMultiCheckboxInput},
      title: 'Manage User Roles',
    mixins: [
        pageTitle,
        commonOptions
    ],
    data: () => ({
      loading: false,
      grantedRoles: [],
      request: null,
      user: null,
    }),

    validations() {
        return {
            grantedRoles: { required: false },
        }
    },
    created() {
        this.requestId = this.$route.params.id
        this.user = this.$route.params.user
        if (this.requestId) {
            this.loadRoleRequest()
        } else if (this.user) {
            this.loadCurrentRoles()
        }
    },
    methods: {
      submit () {
        this.loading = true
          let payload = {
            roles: this.grantedRoles,
            userId: this.user && this.user.userId ? this.user.userId : this.request.requestedUser.userId,
            accessId: this.requestId
          }
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/roles`, payload)
        .then(response => {
            this.loadCurrentRoles()
            this.$bvToast.toast('Roles Updated', {
                title: 'Roles Updated',
                toaster: 'b-toaster-top-center',
                solid: true,
                variant: 'success',
                appendToast: true
            })
            this.loading = false
        })
      },
      loadCurrentRoles() {
          let current = null
          if (this.user) {
              current = this.user.userId
          } else {
              current = this.request.requestedUser.userId
          }
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/roles/current/${current}`)
              .then(response => {
                  this.grantedRoles = response.data
              })
      },
      loadRoleRequest() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/roles/${this.requestId}`)
              .then(response => {
                  this.request = response.data
                  this.loadCurrentRoles()
              })
      },
      sendApprovalEmail() {
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/roles/approved`, {payload: this.requestId}).then(response => {
                  this.$bvToast.toast('Email Sent', {
                      title: 'Email Sent',
                      toaster: 'b-toaster-top-center',
                      solid: true,
                      variant: 'success',
                      appendToast: true
                  })
          })
      },
      sendDenialEmail() {
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/roles/denied`, {payload: this.requestId}).then(response => {
              this.$bvToast.toast('Email Sent', {
                  title: 'Email Sent',
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: 'success',
                  appendToast: true
              })
          })
      },
    }
  }
</script>